import _ from 'lodash'

import { OPEN_DIALOG, CLOSE_DIALOG, DIALOG_SET_LOADING } from './constants'

export function openDialog(type, id = null, settings = {}) {
    const settingsObject = id === null && !_.isEmpty(settings) ? id : settings

    return {
        type: OPEN_DIALOG,
        data: {
            type,
            id,
            settings: settingsObject,
        },
    }
}

export function closeDialog(type, id = null) {
    return {
        type: CLOSE_DIALOG,
        data: {
            type,
            id,
        },
    }
}

export const dialogSetLoading = (type, id, value) => ({
    type: DIALOG_SET_LOADING,
    data: {
        type,
        id,
        value,
    },
})
